var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('BaseForm',[_c('BaseSelect',{attrs:{"label":_vm.$t('Name'),"options":_vm.formattedList,"validate":_vm.validate},on:{"input":function (v){ return _vm.$emit('input', v); }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }